import React from 'react'
import styles from '../styles/utils.module.css'

export default function Buttons() {
  const buttons = [
    {
      name: 'MAIL',
      href: "mailto:kaede0902js@gmail.com",
    },
    {
      name: 'BLOG',
      href: "https://kei-s-lifehack.hatenablog.com/",
    },
    {
      name: 'TWITTER',
      href: "https://twitter.com/kaede_io",
    },
    {
      name: 'GITHUB',
      href: "https://github.com/kaede0902",
    },
  ];
  const buttonExpand = buttons.map(button => {
    return (
      <a className={styles.btn} 
        href={button.href}>
        {button.name}
      </a>
    )
  })
  return (
    <>
      {buttonExpand}
    </>
  )
}
